module.exports = __webpack_public_path__ + "img/part-three.c67aa7a9.jpg";